import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedVariant as setSelectedVariantAction } from '../../Actions/ProductPage.action';
import { setProductPageSelectedVariantQuery as setProductPageSelectedVariantQueryAction } from '../../Actions/ProductPage.action';
import { translate } from '../../Services/translation';
import StockStatusTag from '../StockStatusTag';
import QuantityBuyButton from './QuantityBuyButton';

const VariantPickerContainer = ({
  productVariants,
  hideBuyButton,
  hideQuantityField,
  onVariantSelected,
  isBuyableChannel,
  storesUrl,
  selectedVariantId,
}) => {
  const dispatch = useDispatch();
  const articleIndex = productVariants.findIndex(item => item.articleNumber === selectedVariantId);
  const [selectedVariant, setSelectedVariant] = useState(
      productVariants.length > 1 ? productVariants[articleIndex] : productVariants[0]
  );

  const showCorrectVariantPrice = (variant) => {
    const priceElems = Array.from(
      document.getElementsByClassName('product-page__price')
    );
    priceElems.forEach((element) => {
      if (element.dataset['variantId'] != variant.articleNumber) {
        element.classList.add('product-page__price--hidden');
      } else {
        element.classList.remove('product-page__price--hidden');
      }
    });
  };
  const onVariantClick = (variant) => {
    setSelectedVariant(variant);
    dispatch(setSelectedVariantAction(variant));
    setProductPageSelectedVariantQueryAction(variant)
    if (onVariantSelected) {
      onVariantSelected(variant);
    }
    showCorrectVariantPrice(variant);
  };
  const fixedSizeVariants = productVariants.filter(
    (v) => !v.size.startsWith('Ø')
  );
  const roundSizeVariants = productVariants.filter((v) =>
    v.size.startsWith('Ø')
  );
  return (
    <div className="variant-list">
      {fixedSizeVariants.length > 0 && (
        <div className="variant-list__heading [ text-medium lh-2 bold color-grey-900 ]">
          {translate('product-page.fixed-sizes')}
        </div>
      )}
      <div className="variant-list__list">
        {fixedSizeVariants.length > 0 &&
          fixedSizeVariants.map((variant, index) => (
            <div
              className="[ variant-list__variant ] [ text-medium ]"
              data-active={
                variant.articleNumber === selectedVariant?.articleNumber
                  ? 'active'
                  : 'inactive'
              }
              key={variant.articleNumber}
              onClick={() => {
                onVariantClick(variant);
              }}
            >
              {variant.size}
            </div>
          ))}
      </div>
      {roundSizeVariants.length > 0 && (
        <div className="variant-list__heading variant-list__heading--round [ text-medium lh-2 bold color-grey-900 ]">
          {translate('product-page.round-sizes')}
        </div>
      )}
      <div className="variant-list__list variant-list__list--round">
        {roundSizeVariants.length > 0 &&
          roundSizeVariants.map((variant) => (
            <div
              className="[ variant-list__variant ] [ text-medium ]"
              data-active={
                variant.articleNumber === selectedVariant?.articleNumber
                  ? 'active'
                  : 'inactive'
              }
              key={variant.articleNumber}
              onClick={() => {
                onVariantClick(variant);
              }}
            >
              {variant.size}
            </div>
          ))}
      </div>
      {!hideBuyButton && isBuyableChannel && (
        <div className="[ stock-status stock-status--variants ] [ text-small lh-2 color-grey-900 show-for-medium ]">
          {selectedVariant && (
            <StockStatusTag
              description={selectedVariant.stockStatusDescription}
              stockStatusType={selectedVariant.stockStatusType}
            />
          )}
        </div>
      )}
      {!hideQuantityField && isBuyableChannel && (
        <QuantityBuyButton
          selectedVariantArtNumber={selectedVariant?.articleNumber}
        />
      )}
      {!isBuyableChannel && storesUrl && (
        <a
          style={{ marginTop: '1rem', marginBottom: '1rem', maxWidth: '300px' }}
          className="buy-button"
          href={storesUrl}
        >
          {translate('product-page.find-your-store')}
        </a>
      )}
    </div>
  );
};

export default VariantPickerContainer;
